import { useCallback } from "react";
import { AnalyticsEvent } from "@common/constants/analytics-events";
import { trackEvent } from "@lib/analytics";
import { useOverlays } from "contexts/OverlayContext";

export function useOpenMultiEntityUpgrade() {
    const { openOverlay } = useOverlays();

    return useCallback(() => {
        void trackEvent(AnalyticsEvent.UPSELL_ADD_ENTITY_ATTEMPTED);
        openOverlay("multiEntityUpgrade", true);
    }, [openOverlay]);
}
